import React, { useState } from 'react';
import ActivityLog from '../activity/ActivityLog';
import { useNavigate } from 'react-router-dom';

const PAGE_SIZE = 10;

export default function PaginatedActivity({ activities }) {
  const [page, setPage] = useState(0);
  const navigate = useNavigate();

  const list = activities || [];
  const totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages - 1);
  const start = currentPage * PAGE_SIZE;
  const end = start + PAGE_SIZE;
  const slice = list.slice(start, end);

  // Generate compact page numbers (max 5 visible)
  const pageNumbers = [];
  const maxVisible = 5;
  let startPage = Math.max(0, currentPage - Math.floor(maxVisible / 2));
  let endPage = Math.min(totalPages, startPage + maxVisible);
  if (endPage - startPage < maxVisible) startPage = Math.max(0, endPage - maxVisible);
  for (let i = startPage; i < endPage; i++) pageNumbers.push(i);

  return (
    <div className="activity-panel">
      <div className="activity-panel-header">
        <h3>Recent Activity</h3>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/activity')}>
          View All →
        </button>
      </div>

      {list.length === 0 ? (
        <div className="empty-state" style={{ padding: 40 }}>
          <div className="icon">📜</div>
          <p>No activity yet.</p>
        </div>
      ) : (
        <>
          <ActivityLog activities={slice} />

          {totalPages > 1 && (
            <div className="pagination">
              <button
                className="pg-btn"
                disabled={currentPage === 0}
                onClick={() => setPage(0)}
              >
                «
              </button>
              <button
                className="pg-btn"
                disabled={currentPage === 0}
                onClick={() => setPage((p) => Math.max(0, p - 1))}
              >
                ‹
              </button>
              {pageNumbers.map((p) => (
                <button
                  key={p}
                  className={`pg-btn ${p === currentPage ? 'active' : ''}`}
                  onClick={() => setPage(p)}
                >
                  {p + 1}
                </button>
              ))}
              <button
                className="pg-btn"
                disabled={currentPage >= totalPages - 1}
                onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
              >
                ›
              </button>
              <button
                className="pg-btn"
                disabled={currentPage >= totalPages - 1}
                onClick={() => setPage(totalPages - 1)}
              >
                »
              </button>
              <div className="pg-info">
                {start + 1}–{Math.min(end, list.length)} of {list.length}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
